//generate react component for ContentCard with TypeScript and scss

import './CoralAttribute.scss'

import { Icon, IconProps } from '@coral-library/icons/Icon/Icon'
import React from 'react'

type CoralAttributeProps = {
  label: string
  icon: IconProps['name']
}
export const CoralAttribute: React.FC<CoralAttributeProps> = (props) => {
  return (
    <div className={'coral-attribute'}>
      <div className={'coral-attribute__icon'}>
        <Icon name={props.icon} />
      </div>
      <div className={'coral-attribute__label'}>{props.label}</div>
    </div>
  )
}
